import { io } from 'socket.io-client'
import TokenStorage from './TokenStorage'

// Thin wrapper around the Socket.IO connection already running in
// new-server (strapi.io) — used for live in-app/browser notifications.
// Connects once a user is logged in, joins their `user:<id>` room
// server-side by passing the JWT on the handshake (see new-server/src/index.js).
//
// Listener registration is decoupled from the underlying connection: the
// session-restore check on a fresh page load is async and can flip
// isWeb2UserConnected false→true more than once before settling, which
// causes a disconnect()+reconnect() cycle (Header.vue tears the connection
// down on `false`). A listener added via onNotification() before that churn
// would otherwise stay attached to the now-dead socket and never fire again
// — callbacks are kept in a module-level set and re-attached to whatever
// socket instance is currently live instead.

let socket = null
const callbacks = new Set()

function apiOrigin() {
  // VUE_APP_API_URL is the REST base (e.g. http://localhost:1337/api) —
  // Socket.IO connects to the server origin, not the /api path.
  const apiUrl = process.env.VUE_APP_API_URL || ''
  return apiUrl.replace(/\/api\/?$/, '')
}

function connect() {
  const token = TokenStorage.get()
  if (!token || socket) return socket

  socket = io(apiOrigin(), {
    auth: { token },
    transports: ['websocket', 'polling']
  })

  socket.on('notification', (payload) => {
    callbacks.forEach((cb) => cb(payload))
  })

  return socket
}

function disconnect() {
  if (socket) {
    socket.disconnect()
    socket = null
  }
}

function onNotification(callback) {
  callbacks.add(callback)
  connect()
  return () => callbacks.delete(callback)
}

export default { connect, disconnect, onNotification }
